import { render, staticRenderFns } from "./AdditionalInfo.template.vue?vue&type=template&id=4a307ac8&scoped=true&"
var script = {}
import style0 from "./AdditionalInfo.template.vue?vue&type=style&index=0&id=4a307ac8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a307ac8",
  null
  
)

export default component.exports